import React from "react";
import "./Mission.css";
import MissionCard from "./MissionCard";

const Mission = () => {
  return (
    <div name="mission" className="mission">
      <div className="container">
        <div className="top">
          <h1>Mission</h1>
        </div>
        <MissionCard
          frontTitle="Our mission is to ensure no stray animal suffers by building a digital safety net that empowers every citizen to become a protector"
          frontText="Now you can be the part of a rescue mission. To provide a second chance for every injured animal by connecting them with life-saving care and a compassionate community."
          // backTitle="Discover how we connect rescuers with vets."
          backText="Our platform uses live GPS to find the nearest help for any animal in distress."
        />
        {/* <h3>.</h3>
        <blockquote style={{ fontStyle: 'italic', margin: '1.5rem 0' }}>
          "Until one has loved an animal, a part of one's soul remains unawakened."<br />
          <span style={{ display: 'block', marginTop: '0.5rem', fontWeight: 'bold' }}>– Anatole France</span>
        </blockquote> */}
      </div>
    </div>
  );
};

export default Mission;
